import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';
import { ReferralSummaryDto } from './dto/referral-summary.dto';
import { ReferralType } from './dto/referral-type.dto';
import { ReferralValueReportSearchDto } from './dto/referral-value-report-search.dto';
import { ReferralValueReportDto } from './dto/referral-value-report.dto';
import { WebsiteServiceApiService } from 'src/app/shared/api/website-service-api.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileReferralService {

  constructor(private _apiService: ApiService, private _websiteServiceApi: WebsiteServiceApiService) {}

  public getReferralTypes(): Promise<Array<ReferralType>> {
    return this._apiService.get(`ReferralTypes`);
  }
  public addReferral(referralSummary: ReferralSummaryDto){
    return this._apiService.post(`Referrals`, referralSummary);
  }

  public getRefferalValueReport(search: ReferralValueReportSearchDto): Promise<ReferralValueReportDto> {
    return this._websiteServiceApi.post(`website/v2/referral/referralValueReport`, search);
  }
}
